import LoadingSpinner from "@/components/common/LoadingSpinner";
import SchemaFormView from "@/components/Schema/SchemaFormView";
import { capitalizeText } from "@/lib/capitalizeText";
import { SchemaService } from "@/services/APIs";
import { PageHeader } from "@ant-design/pro-components";
import { createForm } from "@formily/core";
import { useQuery } from "@tanstack/react-query";
import { Card } from "antd";
import { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useA1ResolvedNav } from "@/hooks/useA1ResolvedNav";

const SchemaForm: React.FC = () => {
  const navigationRoutes = useA1ResolvedNav();
  const navigate = useNavigate();
  const { schemaName } = useParams<{ schemaName: string }>();
  const schemaNameParam = schemaName ?? "";
  const { data: schemaInfo, isLoading } = useQuery({
    queryKey: ["schema", schemaName],
    queryFn: () => SchemaService.getSchemaByName(schemaNameParam),
    enabled: !!schemaName,
  });

  const form = useMemo(() => createForm({}), []);
  if (isLoading ?? !schemaInfo) {
    return <LoadingSpinner />;
  }

  return (
    <Card
      title={
        <PageHeader
          className="custom-page-header"
          title={`From ${capitalizeText(schemaName ?? "")}`}
          onBack={() => navigate(navigationRoutes.SCHEMAS)}
        />
      }
    >
      <SchemaFormView form={form} schemaJson={schemaInfo?.json ?? schemaInfo} />
    </Card>
  );
};

export default SchemaForm;
